import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import NotificationSidebar from "../CommonForBoth/NotificationSidebar/NotificationSidebar";
import logo from "../../assets/images/agra_logo2_cropped.png"
import logoLightSvg from "../../assets/images/collapsed.png"
import { useSelector } from "react-redux"
import { withTranslation } from "react-i18next"
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"
import { getNotifications } from "services/notificationServices";
import Explainer from "../Common/Explainers"

const Header = (props) => {

  const { country } = useSelector(state => state.Profile)
  const { countries } = useSelector(state => state.list)
  const [countryName, setCountryName] = useState("")
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  // useEffect(() => {
  //   if (country == localStorage.getItem("COUNTRY") && props.title == "Home") {
  //     let country_name = countries
  //       .filter(c => c.title == country)
  //       .map(cn => cn.label)
  //     setCountryName(country_name[0] ? "- " + country_name[0] : "")
  //   }
  // }, [countries, country])
  useEffect(() => {
    if (country === localStorage.getItem("COUNTRY") && props.title === "Home") {
      let country_name = countries
        .filter((c) => c.title === country)
        .map((cn) => cn.label);
      setCountryName(country_name[0] ? "- " + country_name[0] : "");
    }
  }, [countries, country, props.title]);

  // useEffect(() => {
  //   const fetchUnreadCount = async () => {
  //     try {
  //       console.log("Fetching unread notifications count...");
  //       const response = await getNotifications();
  //       console.log("Unread Notifications API Response:", response);

  //       const notifications = response.data || [];
  //       const unreadNotifications = notifications.filter((n) => !n.is_read);

  //       setUnreadCount(unreadNotifications.length);
  //     } catch (error) {
  //       console.error("Error fetching unread notifications count:", error);
  //     }
  //   };

  //   fetchUnreadCount();
  // }, []);
  const updateUnreadCount = async () => {
    try {
      const response = await getNotifications();
      const notifications = response.data || [];
      // Calculate the number of unread notifications
      const unreadNotifications = notifications.filter((n) => !n.is_read);
      setUnreadCount(unreadNotifications.length);
    } catch (error) {
      console.error("Error fetching unread notifications count:", error);
    }
  };

  useEffect(() => {
    updateUnreadCount();
  }, []);

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
    updateUnreadCount();
  };

  // **Mapping titles to corresponding ExplainerModal components**
  const explainerMap = {
    "Home Page": "HomePageExplainer",
    "Tasks": "TasksExplainer",
    "Policy Landscaping": "PolicyLandscapingExplainer",
    "Policy Benchmarking": "BenchmarkingExplainer",
    "Policy Tracking": "ETrackerPolicyProgressExplainer",
    "E-Tracker": "ETrackerStageInsightsExplainer",
    "Policy Lifecycle Management": "PolicyLifecycleManagementExplainer",
    "Policy Directory": "PolicyDirectoryExplainer",
    "Partner Management": "PolicyPartnerExplainer",
    "Policy Updates and Events": "PolicyUpdatesAndCountryEventsExplainer",
    "Frequently Asked Questions": "FAQsExplainer",
    "Systems Management": "SystemsManagementExplainer",
    "Tracking and Assessment Management": "TrackingAndAssessmentExplainer",
    "Users": "UserManagementExplainer",
    "Organization Management": "UserOrganizationExplainer",
    "Audit Logs": "AuditTrailExplainer",
    "Profile Information": "ProfileInformationExplainer",
    "User Information": "UserInformationExplainer",
  };

  const explainerType = explainerMap[props.title] || null;

  // function toggleFullscreen() {
  //   if (
  //     !document.fullscreenElement &&
  //     /* alternative standard method */ !document.mozFullScreenElement &&
  //     !document.webkitFullscreenElement
  //   ) {
  //     // current working methods
  //     if (document.documentElement.requestFullscreen) {
  //       document.documentElement.requestFullscreen()
  //     } else if (document.documentElement.mozRequestFullScreen) {
  //       document.documentElement.mozRequestFullScreen()
  //     } else if (document.documentElement.webkitRequestFullscreen) {
  //       document.documentElement.webkitRequestFullscreen(
  //         Element.ALLOW_KEYBOARD_INPUT
  //       )
  //     }
  //   } else {
  //     if (document.cancelFullScreen) {
  //       document.cancelFullScreen()
  //     } else if (document.mozCancelFullScreen) {
  //       document.mozCancelFullScreen()
  //     } else if (document.webkitCancelFullScreen) {
  //       document.webkitCancelFullScreen()
  //     }
  //   }
  // }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
              </Link>
            </div>

            {props.iconClass && (
              <span className="me-2">
                {typeof props.iconClass === "string" ? (
                  <i className={`bx ${props.iconClass}`} />
                ) : (
                  props.iconClass // Render Iconify JSX icon
                )}
              </span>
            )}

            <div className="app-search page-title-box d-sm-flex align-items-center items-center gap-2 justify-content-between">
              <h4 className="mb-0 text-muted mt-2">
                {/* <i className={`bx ${props.iconClass}`}></i>{" "} */}
                {props.title.toUpperCase()} {countryName}
              </h4>
              {explainerType && <Explainer type={explainerType} />}
            </div>
          </div>

          <div className="d-flex align-items-center">
            <Badge
              badgeContent={unreadCount}
              color="primary"
              style={{ cursor: "pointer" }}
              onClick={() => setIsSidebarOpen(true)}
            >
              <NotificationsIcon color="action" fontSize="large" />
            </Badge>

            <ProfileMenu />
          </div>
          <NotificationSidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
            onNotificationUpdate={updateUnreadCount}
          />
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
